import React, { useState } from "react";
import DefaultButton from "../../default-button/DefaultButton";
import Rename from "../../../assets/icons/Rename";
import Delete from "../../../assets/icons/Delete";
import { Item } from "../../../misc/types";
import arrowUpGr from "../../../assets/svg/arrow-gray-up.svg";
import arrowDownGr from "../../../assets/svg/arrow-gray-down.svg";
import { SocialCategory, SocialSubcategory } from "../../../types";
import { accessGlobalMiscState } from "../../../stores/misc";
import { showSnackbar, sortById } from "../../../misc/utils";
import { simpleGetter } from "../../../actions/common";
import { socialTranscriptApi } from "../../../api/api";
import { HasRole } from "../../HasRole";

type Props = {
  categoryItems: SocialSubcategory[];
  category: SocialCategory;
};

function SortBtn({
  isSorted,
  sortOrder,
  onClick,
}: {
  isSorted: boolean;
  sortOrder: "asc" | "desc" | null;
  onClick: () => void;
}) {
  return (
    <div className="flex flex-col gap-1 cursor-pointer" onClick={onClick}>
      <img
        className={`h-2 ${isSorted && sortOrder === "asc" ? "opacity-100" : "opacity-50"
          }`}
        src={arrowUpGr}
        alt="Sort Ascending"
      />
      <img
        className={`h-2 ${isSorted && sortOrder === "desc" ? "opacity-100" : "opacity-50"
          }`}
        src={arrowDownGr}
        alt="Sort Descending"
      />
    </div>
  );
}

export default function CategoryItemsTable({ categoryItems, category }: Props) {
  const [sortConfig, setSortConfig] = useState<{
    key: keyof Item | null;
    order: "asc" | "desc" | null;
  }>({ key: null, order: null });

  const handleSort = (key: keyof Item) => {
    setSortConfig((prev) => {
      const newOrder =
        prev.key === key && prev.order === "asc" ? "desc" : "asc";
      return { key, order: newOrder };
    });
  };

  const sortedItems = [...categoryItems].sort(sortById)/*.sort((a, b) => {
    if (!sortConfig.key || !sortConfig.order) return 0;

    const aValue = a[sortConfig.key];
    const bValue = b[sortConfig.key];

    if (aValue < bValue) return sortConfig.order === "asc" ? -1 : 1;
    if (aValue > bValue) return sortConfig.order === "asc" ? 1 : -1;
    return 0;
  });*/

  const openEditModal = (item: SocialSubcategory) => () => {
    accessGlobalMiscState().setBatch({
      socialTranscriptIsAddSubcategoryModalOpen: true,
      socialTranscriptCurrentCategory: category,
      socialTranscriptCurrentSubcategory: item
    });
  }

  const deleteItem = (item: SocialSubcategory) => async () => {
    const response = await simpleGetter(socialTranscriptApi.deleteModel, {
      model: 'SocialSubcategory',
      body: {
        id: item.id
      }
    })
    showSnackbar(response.success ? 'Успешно' : 'Произошла ошибка', response.success ? 'success' : 'error')
    if (response.success) {
      accessGlobalMiscState().setBatch({
        socialTranscriptIsAddSubcategoryModalOpen: false,
        socialTranscriptTriggerFetch: (accessGlobalMiscState().get('socialTranscriptTriggerFetch') || 0) + 1
      })
    }
  }

  return (
    <div className="w-full bg-white mt-4 rounded-lg">
      <div className="w-full flex gap-8 text-nowrap p-4">
        <div className="w-[26%] text-[#5F6B88] text-sm font-medium flex items-center gap-2">
          Наименование пункта
          <SortBtn
            isSorted={sortConfig.key === "title"}
            sortOrder={sortConfig.key === "title" ? sortConfig.order : null}
            onClick={() => handleSort("title")}
          />
        </div>
        <div className="w-[27%] text-[#5F6B88] text-sm font-medium flex items-center gap-2">
          Описание пункта
          <SortBtn
            isSorted={sortConfig.key === "descr"}
            sortOrder={sortConfig.key === "descr" ? sortConfig.order : null}
            onClick={() => handleSort("descr")}
          />
        </div>
        <div className="w-[15%] text-[#5F6B88] text-sm font-medium text-end flex items-center gap-2 ">
          Количество баллов
          <SortBtn
            isSorted={sortConfig.key === "points"}
            sortOrder={sortConfig.key === "points" ? sortConfig.order : null}
            onClick={() => handleSort("points")}
          />
        </div>
        <div className=""></div>
      </div>
      {sortedItems.map((item) => (
        <div
          key={item.id}
          className="w-full flex items-center gap-8 border-t border-[#F0F3FA] px-4 py-3"
        >
          <div className="w-[26%] text-black text-[15px] font-medium">
            {item.name}
          </div>
          <div className="w-[27%] text-[#5F6B88] text-[13px] font-normal">
            {item.description}
          </div>
          <div className="w-[13%] text-[#5F6B88] text-sm font-medium text-end">
            {item.points}
          </div>
          <HasRole roles={['create_social_transcript_categories']}>
            <div className="flex gap-2">
              <DefaultButton
                buttonText="Редактировать"
                additionalStyle="text-[#5F6B88] border-1 border-[#AFB7CA] py-[6px] px-4 font-medium gap-2"
                Icon={Rename}
                onClick={openEditModal(item)}
              />
              {!item.transcript_items?.length && (
                <DefaultButton
                  buttonText="Удалить"
                  additionalStyle="text-[#F12D2D] border-1 border-[#F12D2D] py-[6px] px-4 font-medium gap-2"
                  Icon={Delete}
                  onClick={deleteItem(item)}
                // onClick={() => deleteItem(item.id)}
                />
              )}
            </div>
          </HasRole>
        </div>
      ))}
    </div>
  );
}
